export const appPageTransition = false

export const appLayoutTransition = false

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"preconnect","href":"//app.usercentrics.eu"},{"rel":"preconnect","href":"//api.usercentrics.eu"},{"rel":"preload","href":"//app.usercentrics.eu/browser-ui/latest/loader.js","as":"script"}],"style":[],"script":[{"id":"usercentrics-cmp","src":"https://app.usercentrics.eu/browser-ui/latest/loader.js","data-settings-id":"uC3dvabjTxmWnM","data-disable-tracking":false,"async":true}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const appManifest = true

export const remoteComponentIslands = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'